import { createSlice } from "@reduxjs/toolkit";
import { viewPartners } from "../actions/partnersAction";

const newsSlice = createSlice({
  name: "partners",
  initialState: {
    partners: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(viewPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewPartners.fulfilled, (state, action) => {
        state.loading = false;
        state.partners = action.payload;
      })
      .addCase(viewPartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default newsSlice.reducer;
